const translateCondition = (logical: string) => {
  console.log('logical', logical);
  if (logical === 'and') return true;
  if (logical === 'or') return false;
  throw Error(`invalid logical: ${logical}`);
};
const isGroup = (item: { logical: string }) => item.logical === 'and' || item.logical === 'or';
const createFieldId = (item: any) => `filter_${new Date().getTime()}_${Math.random().toString(36).substring(7)}`;
const createGroupId = (item: {}) => `group_${new Date().getTime()}_${Math.random().toString(36).substring(7)}`;
const getType = (item: any) => (isGroup(item) ? 'group' : 'filter');

export const adapterV2toV1 = (value: any[]) => {
  const main = value[0]; // QB1 only support a group as level 0
  const parseField = (
    currenNode: { fields: any[] },
    parentIdGroup: string,
    mapFilters: {
      [x: string]:
        | {
            parentIdGroup: any;
            idGroup: any;
            idFilter: string | undefined;
            field: any;
            condition: boolean | undefined;
            value: any;
            type: string;
            operator: any;
            target: string;
          }
        | undefined;
    },
    mapGroups: {
      [x: string]:
        | { condition: boolean; idGroup: string; parentIdGroup: any; type: string }
        | { parentIdGroup: string; idGroup: string; condition: boolean; type: string }
        | undefined;
    },
    items: {
      id: string;
      element: {
        parentIdGroup: any;
        idGroup: any;
        idFilter: string | undefined;
        field: any;
        condition: string | boolean;
        value: any;
        type: string;
        operator: any;
      };
      children: never[];
    }[],
  ) => {
    currenNode.fields.forEach(
      (element: {
        column: any;
        logical: string;
        value: any;
        operator: any;
        fields: string | any[];
        additionalInfo?: any;
      }) => {
        const isItGroup = isGroup(element);
        const id = isItGroup ? createGroupId(element) : createFieldId(element);
        const translation = {
          id,
          element: {
            parentIdGroup: isItGroup ? parentIdGroup : undefined,
            idGroup: isItGroup ? id : parentIdGroup,
            idFilter: isItGroup ? undefined : id,
            field: isItGroup ? undefined : element.column,
            condition: isItGroup ? translateCondition(element.logical) : '',
            value: isItGroup ? undefined : element.value,
            type: getType(element),
            operator: isItGroup ? undefined : element.operator,
            additionalInfo: element.additionalInfo,
          },
          children: [],
        };

        const mapGroupsTranslation = isItGroup
          ? {
              condition: translateCondition(element.logical),
              idGroup: id,
              parentIdGroup,
              type: getType(element),
            }
          : undefined;
        const mapFiltersTranslation = !isItGroup
          ? {
              parentIdGroup: isItGroup ? parentIdGroup : undefined,
              idGroup: isItGroup ? id : parentIdGroup,
              idFilter: isItGroup ? undefined : id,
              field: isItGroup ? undefined : element.column,
              condition: isItGroup ? translateCondition(element.logical) : undefined,
              value: isItGroup ? undefined : element.value,
              type: getType(element),
              operator: isItGroup ? undefined : element.operator,
              target: 'value',
            }
          : undefined;

        if (isItGroup) {
          mapGroups[id] = mapGroupsTranslation;
        } else mapFilters[id] = mapFiltersTranslation;
        items.push(translation);

        if (isItGroup && element.fields.length > 0) {
          parseField(element as any, id, mapFilters, mapGroups, translation.children);
        }
      },
    );
  };

  const mainGroup = createGroupId({});
  const mapFilters = {};
  const mapGroups = {
    [mainGroup]: {
      parentIdGroup: 'main',
      idGroup: mainGroup,
      condition: translateCondition(main.logical),
      type: 'group',
    },
  };
  const items: any = [];
  parseField(main, mainGroup, mapFilters, mapGroups, items);
  return {
    step: Math.round(Math.random() * 100) + 1,
    mapFilters,
    mapGroups,
    main: mainGroup,
    items,
  };
};

const getConditionToLogical = (condition: any) => (condition ? 'and' : 'or');

export const adapterV1toV2 = (data: { main: any; mapGroups: { [x: string]: { condition: any } }; items: any }) => {
  const result = [];
  const mainGroup = data.main;
  const init = {
    logical: getConditionToLogical(data.mapGroups[mainGroup].condition),
    fields: [],
  };
  const parseItemsToFields = (
    items: any[],
    result: { column?: any; operator?: any; value?: any; logical?: string; fields?: never[] }[],
  ) => {
    items.forEach((item: { element: any; children: any }) => {
      const { element, children } = item;
      if (element.type === 'filter') {
        result.push({
          additionalInfo: element.additionalInfo,
          column: element.field,
          operator: element.operator,
          value: element.value,
        });
      } else {
        const group = {
          logical: getConditionToLogical(element.condition),
          fields: [],
        };
        parseItemsToFields(children, group.fields);
        result.push(group);
      }
    });
  };

  parseItemsToFields(data.items, init.fields);
  result.push(init);
  return result;
};
